import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
  selector: 'tt-traces-b',
  templateUrl: './traces-b.component.html',
  styleUrls: ['./traces-b.component.css']
})
export class TracesBComponent implements OnInit {
    stockBatchKeyno;

    public stockBatchButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockbatchget', gotoParms: () => this.setting!.stockbatch_keyno ?? '' }];

    public setting?: Setting;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockBatchKeyno = this.stateService.getStateParams()['stockbatch_keyno'];
    }

    private async loadSetting() {
        if (!!this.stockBatchKeyno) {
            this.setting = (await this.datatask.Post(2455, { stockbatch_keyno: this.stockBatchKeyno }))[0];
        }
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid().setRememberId(this.setting!.view_id)
                .setLoadDataFunction({
                    method: this.setting!.p2_datatask_keyno as number,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public onTabChanged() {
        this.loadGrid();
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    stockbatch_keyno: string;
    suppliers_batchno: string;
    prod_id: string;
    prod_name: string;
    quantity: string;
    quantity_stock: string;
    p2_datatask_keyno: string | number;
    view_id: string;
    gb_tracesb_main: string;
}
